<template>
    <a :href="link" title="Instagram" aria-labelledby="instagram-icon-link">
        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z"
                stroke="var(--joy-color-secondary-50)"
                stroke-width="2"
                fill="transparent"
            />
            <path
                d="M17.5 6.51L17.51 6.49889"
                stroke="var(--joy-color-secondary-50)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="white-stroke-hover"
                fill="transparent"
            />
            <path
                d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                stroke="var(--joy-color-secondary-50)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="white-stroke-hover"
                fill="transparent"
            />
        </svg>

        <span id="instagram-icon-link" hidden>Instagram</span>
    </a>
</template>

<script setup lang="ts">
    defineProps<{
        link: string;
    }>();
</script>
